var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeftBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 21,
    viewBox: "0 0 12 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3 0.531214C11.175 0.405923 11.0265 0.306518 10.8631 0.238693C10.6996 0.170868 10.5244 0.135956 10.3474 0.135956C10.1705 0.135956 9.99523 0.170868 9.83178 0.238693C9.66833 0.306518 9.51987 0.405923 9.39489 0.531214L0.450747 9.47536C0.350969 9.57493 0.271809 9.6932 0.217799 9.82341C0.163788 9.95361 0.135986 10.0932 0.135986 10.2342C0.135986 10.3751 0.163788 10.5147 0.217799 10.6449C0.271809 10.7751 0.350969 10.8934 0.450747 10.993L9.39489 19.9371C9.92228 20.4645 10.7726 20.4645 11.3 19.9371C11.8274 19.4097 11.8274 18.5594 11.3 18.032L3.50747 10.2288L11.3107 2.42552C11.8274 1.90889 11.8274 1.04784 11.3 0.531214Z",
    fill: "#1E232C",
    stroke: "#1E232C",
    strokeWidth: 0.27191
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeftBlack);
export default __webpack_public_path__ + "static/media/arrowLeftBlack.ba656a4ba3458f11a2561cd8fd838b3c.svg";
export { ForwardRef as ReactComponent };